import React, { Component } from "react";
import * as Yup from "yup";
import _ from "lodash";
import FormGrid, { FormGridField } from "./FormGrid";
import FormWrapper from "./FormWrapper";
import { FormUtils } from "..";

export interface FormProps {
    fields: FormGridField[];
    initialValues?: any;
    onChange: (...args: any) => any;
    isConfig?: boolean
}

export interface FormState {
    fields: FormGridField[];
    validation: Yup.Schema<any>;
}

class Form extends Component<FormProps, FormState> {
    constructor(props) {
        super(props);

        this.state = {
            fields: this.props.fields.map(field => ({
                ...field,
                key: _.uniqueId()
            })),
            validation: Form.generateValidator(this.props.fields)
        };
    }

    static generateValidator(fields: FormGridField[]): Yup.Schema<any> {
        return Yup.object().shape(
            fields.reduce((accumulator, field) => {
                return {
                    ...accumulator,
                    [field.name]: field.validationSchema
                        ? FormUtils.generateYupValidatorFromSchema(
                              field.validationSchema
                          )
                        : field.validation
                };
            }, {})
        );
    }

    onChange = ({ values, isValid }) => {
        this.props.onChange({
            values,
            isValid
        });
    };

    renderFields(fields) {
        return <FormGrid fields={fields} isConfig={this.props.isConfig}/>;
    }

    static getDerivedStateFromProps(props: FormProps, state) {
        const prevFieldsNames = props.fields.map(
            field => field.fieldOptions.id
        );

        const currentFieldsNames = state.fields.map(
            field => field.fieldOptions.id
        );

        const prevFieldsItems = props.fields.map(field => {
            if (field.fieldType == "bulletsSelector") {
                return field.fieldOptions['items'];
            }
        });

        const currentFieldsItems = state.fields.map(field => {
            if (field.fieldType == "bulletsSelector") {
                return field.fieldOptions.items;
            }
        });

        if (!_.isEqual(prevFieldsNames, currentFieldsNames) || !_.isEqual(prevFieldsItems, currentFieldsItems)) {
            return {
                fields: props.fields.map(field => ({
                    ...field,
                    key: field.key || _.uniqueId()
                })),
                validation: Form.generateValidator(props.fields)
            };
        }
        return null;
    }

    render() {
        return (
            <FormWrapper
                initialValues={this.props.initialValues || {}}
                onChange={this.onChange}
                validation={this.state.validation}
                fields={this.state.fields}
            >
                {this.renderFields(this.state.fields)}
            </FormWrapper>
        );
    }
}

export default Form;
